module.exports = __webpack_public_path__ + "img/excellentcd.16d28549.jpg";